.fp-layout--modal(v-if='isModalOpened' data-test='layout-modal' @click='userCloseModal')
  .fp-modal(data-test='modal' @click='stopPropagation')
    component(:is='modal.component' :options='modal.options')
